import { Component, OnInit, HostBinding } from '@angular/core';
import { MestradoService } from '../../service/mestrado.service';
import { DetalheCursoComponent } from '../detalhe-curso.component';
import { routerTransition } from 'app/shared/animations/router-transition.animation';

@Component({
  selector: 'cm-disciplinas',
  templateUrl: './disciplinas.component.html',
  styleUrls: ['./disciplinas.component.scss'],
  animations: [routerTransition],
})
export class DisciplinasComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';
  
  listaDisciplinas: Object[] = [];

  constructor(
    private disciplinas: MestradoService, 
    private idCurso: DetalheCursoComponent){}

  ngOnInit() {
    const idCurso = this.idCurso.cursoIdentificador;
    this.disciplinas
        .listCursoMestradoId(idCurso)
        .subscribe(disciplina => {
          this.listaDisciplinas = disciplina.cursosposgraduacao;
        });
    
  }

}
